/* eslint-disable import/no-anonymous-default-export */
import { typeformRepository } from '../repositories'

function useGetResultMutation() {
	const [_getResult, { data, isLoading, isSuccess, isError }] =
		typeformRepository.useGetResultMutation()

	async function execute({
		formId,
		responseId,
	}: {
		formId: string
		responseId: string
	}) {
		try {
			await _getResult({ formId, responseId }).unwrap()
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess, isError }
}

export default {
	getResultMutation: useGetResultMutation,
}
